import { render, staticRenderFns } from "./ServerConfig.vue?vue&type=template&id=2115fb4a"
import script from "./ServerConfig.vue?vue&type=script&lang=js"
export * from "./ServerConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports